"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function resolveUrlFactory(glob, path, sassGlobPattern) {
  return function (url) {
    var includePaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _path$parse = path.parse(url),
        dir = _path$parse.dir,
        base = _path$parse.base;

    var baseGlobPattern = sassGlobPattern(base);
    var resolvedUrls = [];
    includePaths.some(function (includePath) {
      resolvedUrls = glob.sync(path.resolve(includePath, dir, baseGlobPattern));
      return resolvedUrls.length > 0 || false;
    });
    return resolvedUrls[0] || url;
  };
}

exports.resolveUrlFactory = resolveUrlFactory;